import { Box, styled } from '@mui/material';
import { colors, Tooltip } from '@sweep-io/sweep-design';
import { Reorder } from '@sweep-io/sweep-design/dist/icons';

const StyledDragHandle = styled(Box)(({ theme }) => ({
  width: '26px',
  height: '26px',
  borderRadius: '50%',
  border: `2px solid ${colors.blue[500]}`,
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'white',
  '& svg path': {
    fill: colors.blue[500],
  },
  '&:hover, &.dragging': {
    background: colors.blue[500],
    border: `1px solid ${colors.blue[500]}`,
    '& svg path': {
      fill: 'white',
    },
  },
}));

export const DragHandle = ({ isDragging }: { isDragging?: boolean }) => {
  const handle = (
    <StyledDragHandle className={isDragging ? 'dragging' : ''}>
      <Reorder />
    </StyledDragHandle>
  );
  if (!isDragging) {
    return (
      <Tooltip title="Click and drag to rearrange steps" placement="top" disablePortal>
        {handle}
      </Tooltip>
    );
  }
  return handle;
};
